import React, { useRef } from "react";
import TransparentButton from "../transparentButton/TransparentButton";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const KeyInsights = ({
  overviewDescription,
  categoryLabel = "By Race",
  categoryDescription,
  recommendationDescription,
}) => {
  const insightsRef = useRef();

  const handleExportPDF = async () => {
    const element = insightsRef.current;

    const exportButton = document.getElementById("export-button");
    exportButton.style.display = "none";

    const canvas = await html2canvas(element, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("key-insights.pdf");

    exportButton.style.display = "block";
  };

  return (
    <div
      ref={insightsRef}
      className="flex flex-col gap-5 py-6 px-4 sm:px-6 md:px-10 bg-white rounded-xl shadow-md w-full max-w-full overflow-x-auto"
    >
      <p className="text-custom-blue font-bold text-lg sm:text-xl">
        Key Insights
      </p>

      <div className="flex flex-col gap-4 text-sm sm:text-base font-normal text-gray-700">
        {overviewDescription && (
          <p>
            <strong>Overview: </strong>
            {overviewDescription}
          </p>
        )}
        {categoryDescription && (
          <p>
            <strong>{categoryLabel}: </strong>
            {categoryDescription}
          </p>
        )}
        {recommendationDescription && (
          <p>
            <strong>Recommendation: </strong>
            {recommendationDescription}
          </p>
        )}
      </div>

      <div className="flex justify-end">
        <div id="export-button">
          <TransparentButton
            buttonText={"Export as PDF"}
            onClick={handleExportPDF}
          />
        </div>
      </div>
    </div>
  );
};

export default KeyInsights;
